import httpService from './core/http.service';

class RequestTraceService {
    analyze(file, companyId, toleranceSeconds) {
        const query = [];
        if (companyId) query.push(`companyId=${encodeURIComponent(companyId)}`);
        if (toleranceSeconds) query.push(`toleranceSeconds=${encodeURIComponent(toleranceSeconds)}`);
        const suffix = query.length ? `?${query.join('&')}` : '';
        return httpService.postFile(`/request-trace/analyze${suffix}`, file);
    }
}

export default new RequestTraceService();
